import getColors from "@/shared/colors";
import { TemplateProps } from "./types";

/**
 * Get computed colors with hover states for CSS generation
 */
export function getComputedColors(color: string) {
  return getColors(color);
}

/**
 * Extract style values from props for easier CSS generation
 */
export function extractStyleValues(props: TemplateProps) {
  return {
    cardBackgroundColor: props["card:backgroundColor"],
    cardBorderRadius: props["card:borderRadius"],
    captionBackgroundColor: props["caption:backgroundColor"],
    captionBorderRadius: props["caption:borderRadius"],
    headingColor: props["heading:color"],
    paragraphColor: props["paragraph:color"],
    buttonBackgroundColor: props["button:backgroundColor"],
    buttonBorderRadius: props["button:borderRadius"],
    buttonLabel: props["button:label"],
  };
}

